import React, { cloneElement, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import TYPE from "../../../../constant/TYPE";
import useAmplitude from "../../../../hooks/useAmplitude";
import { loadAIDiagnosisQuestionAction, setAnsweringQuestionsAction } from "../../../../redux/answeringQuestions/answeringQuestions";

const QuestionPassor = ( props ) => {

  const dispatch = useDispatch();
  const answeringQuestions = useSelector(state => state.answeringQuestions);
  const loadAIDiagnosisQuestion = payload => { dispatch( loadAIDiagnosisQuestionAction( payload ) ) };
  const setAnsweringQuestions = payload => { dispatch(setAnsweringQuestionsAction(payload)) };

  const { setAmplitudeLog } = useAmplitude();

  const pass = () => {
    setAnsweringQuestions({ randomMultipleAnswer: [], });
    setAmplitudeLog({
      eventName: {
        name: '진단문항풀이 Pass',
        event: {
          "소주제이름": answeringQuestions?.data?.stepNm,
          "소주제코드": answeringQuestions?.data?.stgCd,
          "문항코드": answeringQuestions?.data?.qstCd,
          "커리큘럼그룹": answeringQuestions?.data?.thmaNm,
          "커리큘럼명": answeringQuestions?.data?.stepNm,
        }
      },
      isHackleSend: true,
    });
    loadAIDiagnosisQuestion( {
      progressCode : TYPE.ANSWERING_QUESTIONS_PROGRESS.CONTINUE,
      pass : true
    } );
  };

  return cloneElement( props.children || <Fragment />, {
    onPass : pass
  } );

};

export default QuestionPassor;
